export enum AnalysisStatus {
    PENDING = 'Pending',
    ERROR = 'Error',
    COMPLETED = 'Finished',
}

export enum EnvironmentalRiskCategory {
    VERY_LOW = 'Negligible risk',
    LOW = 'Low',
    MEDIUM = 'Moderate risk',
    HIGH = 'High',
    SEVERE = 'Severe',
    EXTREME = 'Extreme',
}

export const SampleProjectId = "297d187b-1c53-44a6-a709-2bae1ce81599";